import axios from "@/app/plugins/Axios";
import qs from "qs";
import { parseParams } from "../helpers/utils";

function finalizarPedido(pedido) {
  return axios.post(`/pdv/finalizar`, pedido).then((response) => response.data);
}


export default {
  finalizarPedido,
}